// extracted by mini-css-extract-plugin
export default {"block":"Question_block__17cnm","question":"Question_question__iNsWm"};